// eslint-disable-next-line @ms/forbid-file-names
import { CurrentNetworkContext } from '@ms/yammer-data/dist/state/types';

type GetBasenameWithNetworkContext = (basename: string, networkContext: CurrentNetworkContext) => string;
export const getBasenameWithNetworkContext: GetBasenameWithNetworkContext = (basename, networkContext) => {
  const networkPath = networkContext && networkContext.networkPath.length > 0 ? '/' + networkContext.networkPath : '';

  return `${basename}${networkPath}`;
};
